import { render, staticRenderFns } from "./SelectGroupQuantitiesStory.vue?vue&type=template&id=62c59eb2&"
import script from "./SelectGroupQuantitiesStory.vue?vue&type=script&lang=ts&"
export * from "./SelectGroupQuantitiesStory.vue?vue&type=script&lang=ts&"
import style0 from "./SelectGroupQuantitiesStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports